import {
  formatter,
  listTimeTitleFunc,
} from '@/pages/opinion/components/ChartCommon/formatter';
import { reviewsFormat } from '@/pages/opinion/utils/value';

export default function echartsFormatter(
  params: any,
  option: string,
  data: any,
  filter: any,
  formatMessage: any,
) {
  const { date_type: dateType } = filter;
  let title: any;
  if (params.length > 0) {
    title = listTimeTitleFunc(params[0]?.axisValue, dateType, true);
  }
  if (option === 'mdauOption') {
    const records = [
      {
        type: 'Mentions',
        paramsIndex: 0,
      },
      {
        type: 'Sensor Tower',
        paramsIndex: 4,
      },
      {
        type: 'Predicted',
        paramsIndex: 5,
      },
      {
        type: 'Positive',
        paramsIndex: 1,
      },
      {
        type: 'Neutral',
        paramsIndex: 2,
      },
      {
        type: 'Negative',
        paramsIndex: 3,
      },
    ].filter((item) => {
      const { type, paramsIndex } = item;
      if (['Sensor Tower', 'Predicted'].includes(type)) {
        const { value } = params[paramsIndex] || {};
        const value1 = params[4];
        const value2 = params[5];
        if (value1 === value2 && type === 'Sensor Tower') return false;
        if (value === '-' || value === undefined) return false;
      }
      return true;
    });

    return formatter({
      title,
      tables: [
        {
          showHeader: false,
          records,
          columns: [
            {
              key: 'type',
              render(record: any) {
                const { type, paramsIndex } = record;
                const { color, seriesName } = params[paramsIndex] || {};

                // console.log(params[paramsIndex]);

                if (type !== 'Mentions') {
                  return `<span style="background:${color};" class="chart-common-formatter-circle"></span>${formatMessage(
                    { id: seriesName },
                  )}`;
                }
                return formatMessage({ id: type });
              },
            },
            {
              weight: 'bold',
              align: 'right',
              key: 'score',
              render(record: any) {
                const { paramsIndex, type } = record;
                const { value: score } = params[paramsIndex] || {};
                if (type === 'Sentiment') return score;
                else return reviewsFormat(score);
              },
            },
          ],
        },
      ],
    });
  }
}
